import * as utils from '../../../shared/utils';

const handleDragLeave = () => {
  const $cursorReorderImages = document.querySelector('.cursorReorderImages');
  if ($cursorReorderImages) utils.css($cursorReorderImages, { display: 'none' });
};

export default handleDragLeave;
